<button
  mat-stroked-button
  fxFlex="100"
  fxFlex.xs="98"
  fxFlex.md="20"
  class="buttonWidth"
  color="{{ dateFilter.startDate || dateFilter.endDate ? 'primary' : 'gray' }}"
>
  <div class="filter-calendar-container">
    <div
      class="person-filter"
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <div fxLayout="row" [matMenuTriggerFor]="menuCalendar">
        <div fxLayoutAlign="center center" *ngIf="!dateText" fxFlex="100">
          <span class="person-text">Start - End Date</span
          ><span class="material-icons font-size-16"> arrow_drop_down </span>
        </div>
        <div fxLayoutAlign="center center" *ngIf="dateText" fxFlex="100">
          <span class="person-text">{{ dateText | titlecase }}</span>
        </div>
      </div>
      <div *ngIf="dateText" (click)="resetFilters()" class="remove-filter">
        <mat-icon>close</mat-icon>
      </div>
    </div>
    <mat-menu #menuCalendar="matMenu" class="menu-calendar">
      <app-calendar
        [clearFilter]="clearFilter"
        (click)="$event.stopPropagation()"
        (changeDate)="selectedDate($event)"
        #calendar
      ></app-calendar>
    </mat-menu>
  </div>
</button>
